// @dynamic
export class IsMenuReadyServiceUtils {
  static readonly renderSignalBundlerDebounceTime = 2000;
}
